import React from 'react';
import { Calendar } from 'primereact/calendar';

function PrimeReactCalendar(props) {
  const { selectionMode = 'single', name = '', value = '', onChange = (e) => {}, showIcon = false, ...rest } = props || {};
  return (
    <Calendar
      selectionMode={selectionMode}
      name={name}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      showIcon={showIcon}
      {...rest}
    />
  );
}

export default PrimeReactCalendar;
